import TrackingEvent from '~/lib/analytics/TrackingEvent'
import { EmailVerificationStatusType } from './emailVerificationStatus'
import { NewPasswordVerificationStatusType } from './newPasswordVerificationStatus'
import { CodeVerificationStatusType } from './codeVerificationStatus'

/**
 * This event is triggered when a user signs in.
 */
export class SignedInEvent extends TrackingEvent {
  constructor() {
    super('Signed In')
  }
}

/**
 * This event is triggered when a user requests to reset his password.
 */
export class PasswordResetEvent extends TrackingEvent {
  constructor() {
    super('Password Reset Requested')
  }
}

/**
 * This event is triggered when a new user signs up.
 */
export class SignedUpEvent extends TrackingEvent {
  constructor() {
    super('Signed Up')
  }
}

/**
 * This event is triggered when a user clicks on Confirm Patient Information button on the Booking Flow.
 */
export class ConfirmPatientInformationEvent extends TrackingEvent {
  constructor() {
    super('Button Clicked')
  }

  public properties() {
    return {
      action: 'Confirm Patient Information',
    }
  }
}

export class ZocdocEmailVerificationInitiatedEvent extends TrackingEvent {
  constructor(private result: EmailVerificationStatusType) {
    super('Zocdoc Email Verification Initiated')
  }

  public properties() {
    return {
      result: this.result,
    }
  }
}

export class ZocdocPhoneVerificationInitiatedEvent extends TrackingEvent {
  constructor(private result: CodeVerificationStatusType) {
    super('Zocdoc Phone Verification Initiated')
  }

  public properties() {
    return {
      result: this.result,
    }
  }
}

export class ZocdocAccountActivatedEvent extends TrackingEvent {
  constructor(private result: NewPasswordVerificationStatusType) {
    super('Zocdoc Account Activated')
  }

  public properties() {
    return {
      result: this.result,
    }
  }
}
